import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { FormControl, InputLabel, TextField } from "@mui/material";

import Card from "../../components/Cards/Card";
import Venn from "../../components/Charts/Venn";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import Modal from "../../components/Modal/Modal";
import NativeObject from "../../components/NativeObject/NativeObject";
import AnalisePdv from "./Modais/AnalisePdv";
import ConjuntosBasket from "./Modais/ConjuntosBasket";

import { useSelections } from "../../context/Selections";

import handDrag from "../../assets/icons/hand-drag.png";
import TooltipInfo from "../../components/TooltipInfo/TooltipInfo";

const ConjuntoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 230px;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;

  flex-direction: column;
  padding: 8px 0px;
  justify-content: center;
  .primaryButton .pdv {
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;

function BasketMixMobile({ app, config }) {
  const { cards } = config.basketMix;

  const [valueInputA, setValueInputA] = useState(0);
  const [valueInputB, setValueInputB] = useState(0);

  const [vSelloutPR, setVSelloutPR] = useState("");
  const [vSelloutUNDPR, setVSelloutUNDPR] = useState("");
  const [vPrecoMedioPR, setVPrecoMedioPR] = useState("");
  const [vPDVSCompradoresPR, setVPDVSCompradoresPR] = useState("");
  const [vVendedoresPR, setVVendedoresPR] = useState("");
  const [vTotalSKUPR, setVTotalSKUPR] = useState("");
  const [vOportunidadePR, setVOportunidadePR] = useState("");

  const [vSelloutOCS, setVSelloutOCS] = useState("");
  const [vSelloutUNDOCS, setVSelloutUNDOCS] = useState("");
  const [vPrecoMedioOCS, setVPrecoMedioOCS] = useState("");
  const [vPDVSCompradoresOCS, setVPDVSCompradoresOCS] = useState("");
  const [vVendedoresOCS, setVVendedoresOCS] = useState("");
  const [vTotalSKUOCS, setVTotalSKUOCS] = useState("");
  const [vOportunidadeOCS, setVOportunidadeOCS] = useState("");

  const [modalOpened, setModalOpened] = useState(false);
  const [modalOpenedPdvs, setModalOpenedPdvs] = useState(false);
  const conjuntoModal = useRef(0);
  const analiseModal = useRef(0);

  const { selections } = useSelections();

  function initialDataTable() {
    app.variable.getContent("vSelloutPR", (reply) => {
      const data = reply.qContent.qString;
      setVSelloutPR(data);
    });
    app.variable.getContent("vSelloutUNDPR", (reply) => {
      const data = reply.qContent.qString;
      setVSelloutUNDPR(data);
    });
    app.variable.getContent("vPrecoMedioPR", (reply) => {
      const data = reply.qContent.qString;
      setVPrecoMedioPR(data);
    });
    app.variable.getContent("vPDVSCompradoresPR", (reply) => {
      const data = reply.qContent.qString;
      setVPDVSCompradoresPR(data);
    });
    app.variable.getContent("vVendedoresPR", (reply) => {
      const data = reply.qContent.qString;
      setVVendedoresPR(data);
    });
    app.variable.getContent("vTotalSKUPR", (reply) => {
      const data = reply.qContent.qString;
      setVTotalSKUPR(data);
    });
    app.variable.getContent("vOportunidadePR", (reply) => {
      const data = reply.qContent.qString;
      setVOportunidadePR(data);
    });

    app.variable.getContent("vSelloutOCS", (reply) => {
      const data = reply.qContent.qString;
      setVSelloutOCS(data);
    });
    app.variable.getContent("vSelloutUNDOCS", (reply) => {
      const data = reply.qContent.qString;
      setVSelloutUNDOCS(data);
    });
    app.variable.getContent("vPrecoMedioOCS", (reply) => {
      const data = reply.qContent.qString;
      setVPrecoMedioOCS(data);
    });
    app.variable.getContent("vPDVSCompradoresOCS", (reply) => {
      const data = reply.qContent.qString;
      setVPDVSCompradoresOCS(data);
    });
    app.variable.getContent("vVendedoresOCS", (reply) => {
      const data = reply.qContent.qString;
      setVVendedoresOCS(data);
    });
    app.variable.getContent("vTotalSKUOCS", (reply) => {
      const data = reply.qContent.qString;
      setVTotalSKUOCS(data);
    });
    app.variable.getContent("vOportunidadeOCS", (reply) => {
      const data = reply.qContent.qString;
      setVOportunidadeOCS(data);
    });
  }

  async function initialInputs() {
    await app.variable.getContent("vSimuladorA", (reply) => {
      const data = reply.qContent.qString;
      if (data !== undefined) {
        setValueInputA(parseInt(data, 10));
      }
    });
    await app.variable.getContent("vSimuladorB", (reply) => {
      const data = reply.qContent.qString;
      if (data !== undefined) {
        setValueInputB(parseInt(data, 10));
      }
    });
    await app.variable.setNumValue("vSimuladorSliderA", 0);
    await app.variable.setNumValue("vSimuladorSliderB", 0);
  }

  async function handleChangeInputA(event) {
    setValueInputA(event.target.value);
    if (app) {
      await app.variable.setNumValue(
        "vSimuladorA",
        parseInt(event.target.value, 10)
      );
    }
  }

  async function handleChangeInputB(event) {
    setValueInputB(event.target.value);
    if (app) {
      await app.variable.setNumValue(
        "vSimuladorB",
        parseInt(event.target.value, 10)
      );
    }
  }

  function showModal(index) {
    conjuntoModal.current = index;
    setModalOpened(true);
  }
  function showModalPdvs(index) {
    analiseModal.current = index;
    setModalOpenedPdvs(true);
  }

  function closeModal() {
    setModalOpened(false);
  }
  function closeModalPdvs() {
    setModalOpenedPdvs(false);
  }

  useEffect(() => {
    if (app) {
      initialInputs();
    }
  }, []);

  useEffect(() => {
    // console.log("alter app");
    if (app) {
      initialDataTable();
    }
  }, [selections]);

  const ModalButton = ({ title, onClick, color, pdv, tooltip }) => (
    <ButtonWrapper>
      <div className="primaryButton pdv" aria-hidden="true" onClick={onClick}>
        {pdv ? (
          <button
            style={{
              width: "100%",
              height: "40px",
              background: color,
              color: "#fff",
            }}
            type="button"
          >
            <div
              className="row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <span>{title}</span>
              {tooltip && (
                <TooltipInfo
                  text={tooltip}
                  style={{ color: "#fff", marginLeft: "8px" }}
                />
              )}
            </div>
          </button>
        ) : (
          <button style={{ width: "100%", height: "40px" }} type="button">
            <div
              className="row"
              style={{ alignItems: "center", justifyContent: "space-between" }}
            >
              <span>{title}</span>
              <i style={{ color: color }} className="fas fa-chevron-down" />
            </div>
          </button>
        )}
      </div>
    </ButtonWrapper>
  );

  return (
    <div className="app basketMix">
      <div className="appContent">
        {modalOpened && (
          <Modal
            title="Conjuntos"
            show={modalOpened}
            setShow={() => closeModal()}
            closeButton
          >
            <ConjuntosBasket
              app={app}
              config={config}
              index={conjuntoModal.current}
            />
          </Modal>
        )}
        {modalOpenedPdvs && (
          <Modal
            title="PDVs não compradores"
            show={modalOpenedPdvs}
            setShow={() => closeModalPdvs()}
            closeButton
          >
            <AnalisePdv
              app={app}
              config={config}
              index={analiseModal.current}
            />
          </Modal>
        )}
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card style={{ background: "#365698", height: "100%" }}>
            <ConjuntoWrapper
              style={{
                border: "1.09091px solid #F8F8F8",
                boxShadow: "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                borderRadius: "4.36364px",
                background: "#fff",
                padding: "8px",
                height: "40%",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "40px",
                  borderRadius: "5px 5px 0px 0px",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  borderBottom: "1px solid #F3F1F1",
                }}
              >
                <ComboHeader
                  reference={{
                    title: {
                      id: "header.titleId",
                      hard: "Pré-Requisito (PR)",
                    },
                  }}
                  tooltip="Pré-Requisito (Coluna Azul): Principal produto ou categoria que deseja usar como foco de comparação"
                />
              </div>
              <div
                style={{
                  borderBottom: "1px solid #F3F1F1",
                  marginBottom: "8px",
                }}
              >
                <ModalButton
                  title="Selecione uma ou mais marcas"
                  onClick={() => showModal(0)}
                  color="#365698"
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateRows: "repeat(7, 1fr)",
                  rowGap: "8px",
                }}
                className="listRsultados"
              >
                <div>
                  <h3>Sell Out (R$)</h3>
                  <h4>{vSelloutPR}</h4>
                </div>
                <div>
                  <h3>Sell Out (Und)</h3>
                  <h4>{vSelloutUNDPR}</h4>
                </div>
                <div>
                  <h3>Preço Médio (Und)</h3>
                  <h4>{vPrecoMedioPR}</h4>
                </div>
                <div>
                  <h3>PDVs Compradores</h3>
                  <h4>{vPDVSCompradoresPR}</h4>
                </div>
                <div>
                  <h3>Vendedores</h3>
                  <h4>{vVendedoresPR}</h4>
                </div>
                <div>
                  <h3>Total de items (SKUs)</h3>
                  <h4>{vTotalSKUPR}</h4>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexLDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h2>PDVs com Oportunidade</h2>
                <h3 style={{ fontWeight: "600", color: "#000" }}>
                  {vOportunidadePR}
                </h3>
              </div>
            </ConjuntoWrapper>
            <ConjuntoWrapper
              style={{
                boxShadow: "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                borderRadius: "4.36364px",
                background: "#fff",
                height: "50%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "50%",
                  borderTopLeftRadius: "4.36364px",
                  borderTopRightRadius: "4.36364px",
                  padding: "8px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "5px 5px 0px 0px",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    borderBottom: "1px solid #F3F1F1",
                    marginBottom: "8px",
                  }}
                >
                  <ComboHeader
                    reference={{
                      title: {
                        id: "subtitle?.hard",
                        hard: "Simular Oportunidade",
                      },
                    }}
                    tooltip="Simule uma estimativa de volume médio em unidades para PDVs com oportunidade de positivação com Itens PR"
                  />
                </div>

                <div className="hideTitleSlider">
                  <NativeObject
                    app={app}
                    reference={{ id: "NYyAkB" }}
                    style={{
                      width: "100%",
                      height: "50px",
                    }}
                  />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={handDrag} alt="mova o slider" />
                    <span>Escolha o percentual de PDVs com oportunidades</span>
                    <TooltipInfo
                      text="Slider para escolher percentual de captura em PDVs com oportunidade"
                      style={{ marginLeft: "8px" }}
                    />
                  </div>
                </div>
                <div style={{ marginTop: "16px" }}>
                  <FormControl>
                    <InputLabel htmlFor="component-outlined"></InputLabel>
                    <TextField
                      id="component-outlined"
                      size="small"
                      label="Digite o Volume desejado (Unid)"
                      fullWidth
                      defaultValue={valueInputA}
                      onBlur={handleChangeInputA}
                      type="number"
                    />
                  </FormControl>
                </div>
              </div>
              <div
                className="titleKpiSimulador"
                style={{
                  background: "#ebf3fb",
                  width: "100%",
                  height: "50%",
                  borderBottomLeftRadius: "4.36364px",
                  borderBottomRightRadius: "4.36364px",
                }}
              >
                <div
                  style={{
                    background: "#ebf3fb",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <Card style={{}}>
                      <NativeObject
                        app={app}
                        reference={{ id: "EdhktTB" }}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                      />
                    </Card>
                  </div>
                  <div
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <Card>
                      <NativeObject
                        app={app}
                        reference={{ id: "gWLGykS" }}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                      />
                    </Card>
                  </div>
                  <div
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <Card>
                      <NativeObject
                        app={app}
                        reference={{ id: "azEfWYV" }}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                      />
                    </Card>
                  </div>
                  <div
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <Card>
                      <NativeObject
                        app={app}
                        reference={{ id: "UJBUpm" }}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                      />
                    </Card>
                  </div>
                </div>
                <div
                  style={{
                    background: "#ebf3fb",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                >
                  <ModalButton
                    title="Visualizar PDVs"
                    onClick={() => showModalPdvs(0)}
                    color="#4B81D0"
                    pdv
                    tooltip="Visualize a listagem de PDVs com oportunidade de positivação com Itens PR"
                  />
                </div>
              </div>
            </ConjuntoWrapper>
          </Card>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card style={{ height: "100%", width: "100%" }}>
            <div
              style={{
                marginTop: "12px",
                borderBottom: "1px solid #F3F1F1",
                marginBottom: "8px",
              }}
            >
              <ComboHeader
                reference={{
                  title: {
                    id: "header.titleId",
                    hard: "PDVs compradores de PR vs OCS",
                  },
                }}
                tooltip="No gráfico de círculos temos uma visão de totais de PDVs que compraram apenas o PRODUTO A (lado azul), que compraram PRODUTO A+B (centro - azul/vermelho) e que compraram apenas PRODUTO B (lado vermelho)."
              />
            </div>

            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "55%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Venn
                  app={app}
                  reference={{ id: "yXeJ" }}
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    width: "100% !important",
                  }}
                />
              </div>

              <div
                style={{
                  width: "100%",
                  height: "45%",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "30px",
                    color: "#fff",
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    justifyItems: "center",
                    background:
                      "linear-gradient(90deg, #365698 33%, #947C92 33% 66%, #F6540E 66% 100%)",
                  }}
                >
                  <span>PR</span>
                  <span>PR e OCS</span>
                  <span>OCS</span>
                </div>

                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "start",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      justifyContent: "start",
                    }}
                  >
                    <NativeObject
                      app={app}
                      reference={{ id: "jkKGdvz" }}
                      style={{
                        width: "100%",
                        height: "60px",
                      }}
                    />
                    <NativeObject
                      app={app}
                      reference={{ id: "qprvfS" }}
                      style={{
                        width: "100%",
                        height: "60px",
                      }}
                    />

                    <NativeObject
                      app={app}
                      reference={{ id: "mdtPf" }}
                      style={{
                        width: "100%",
                        height: "60px",
                      }}
                    />
                    <NativeObject
                      app={app}
                      reference={{ id: "FQMUcs" }}
                      style={{
                        width: "100%",
                        height: "60px",
                      }}
                    />

                    <NativeObject
                      app={app}
                      reference={{ id: "RGCnYS" }}
                      style={{
                        width: "100%",
                        height: "60px",
                      }}
                    />
                    <NativeObject
                      app={app}
                      reference={{ id: "mXLuPCj" }}
                      style={{
                        width: "100%",
                        height: "60px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card style={{ background: "#F6540E", height: "100%" }}>
            <ConjuntoWrapper
              style={{
                border: "1.09091px solid #F8F8F8",
                boxShadow: "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                borderRadius: "4.36364px",
                background: "#fff",
                padding: "8px",
                height: "40%",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "40px",
                  borderRadius: "5px 5px 0px 0px",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  borderBottom: "1px solid #F3F1F1",
                }}
              >
                <ComboHeader
                  reference={{
                    title: {
                      id: "header.titleId",
                      hard: "Cross-Selling (OCS)",
                    },
                  }}
                  tooltip="Cross-Selling (Coluna Vermelha): Produto ou categoria que deseja comparar com pré-requisito. Por exemplo, um produto que queira aumentar a penetração. "
                />
              </div>
              <div
                style={{
                  borderBottom: "1px solid #F3F1F1",
                  marginBottom: "8px",
                }}
              >
                <ModalButton
                  title="Selecione uma ou mais marcas"
                  onClick={() => showModal(0)}
                  color="#F6540E"
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateRows: "repeat(7, 1fr)",
                  rowGap: "8px",
                }}
                className="listRsultados"
              >
                <div>
                  <h3>Sell Out (R$)</h3>
                  <h4>{vSelloutOCS}</h4>
                </div>
                <div>
                  <h3>Sell Out (Und)</h3>
                  <h4>{vSelloutUNDOCS}</h4>
                </div>
                <div>
                  <h3>Preço Médio (Und)</h3>
                  <h4>{vPrecoMedioOCS}</h4>
                </div>
                <div>
                  <h3>PDVs Compradores</h3>
                  <h4>{vPDVSCompradoresOCS}</h4>
                </div>
                <div>
                  <h3>Vendedores</h3>
                  <h4>{vVendedoresOCS}</h4>
                </div>
                <div>
                  <h3>Total de items (SKUs)</h3>
                  <h4>{vTotalSKUOCS}</h4>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexLDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h2>PDVs com Oportunidade</h2>
                <h3 style={{ fontWeight: "600", color: "#000" }}>
                  {vOportunidadeOCS}
                </h3>
              </div>
            </ConjuntoWrapper>
            <ConjuntoWrapper
              style={{
                boxShadow: "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                borderRadius: "4.36364px",
                background: "#fff",
                height: "50%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "50%",
                  borderTopLeftRadius: "4.36364px",
                  borderTopRightRadius: "4.36364px",
                  padding: "8px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "5px 5px 0px 0px",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    borderBottom: "1px solid #F3F1F1",
                    marginBottom: "8px",
                  }}
                >
                  <ComboHeader
                    reference={{
                      title: {
                        id: "header.titleId",
                        hard: "Simular Oportunidade",
                      },
                    }}
                    tooltip="Simule uma estimativa de volume médio em unidades para PDVs com oportunidade de positivação com Itens OCS"
                  />
                </div>

                <div className="hideTitleSlider">
                  <NativeObject
                    app={app}
                    reference={{ id: "jzMAW" }}
                    style={{
                      width: "100%",
                      height: "50px",
                    }}
                  />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={handDrag} alt="mova o slider" />
                    <span>Escolha o percentual de PDVs com oportunidades</span>
                    <TooltipInfo
                      text="Slider para escolher percentual de captura em PDVs com oportunidade"
                      style={{ marginLeft: "8px" }}
                    />
                  </div>
                </div>
                <div style={{ marginTop: "16px" }}>
                  <FormControl>
                    <InputLabel htmlFor="component-outlined"></InputLabel>
                    <TextField
                      id="component-outlined"
                      size="small"
                      label="Digite o Volume desejado (Unid)"
                      fullWidth
                      defaultValue={valueInputB}
                      onBlur={handleChangeInputB}
                      type="number"
                    />
                  </FormControl>
                </div>
              </div>
              <div
                className="titleKpiSimulador"
                style={{
                  background: "#ebf3fb",
                  width: "100%",
                  height: "50%",
                  borderBottomLeftRadius: "4.36364px",
                  borderBottomRightRadius: "4.36364px",
                }}
              >
                <div
                  style={{
                    background: "#ebf3fb",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <Card style={{}}>
                      <NativeObject
                        app={app}
                        reference={{ id: "xTrcnJ" }}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                      />
                    </Card>
                  </div>
                  <div
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <Card>
                      <NativeObject
                        app={app}
                        reference={{ id: "tBReZ" }}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                      />
                    </Card>
                  </div>

                  <div
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <Card>
                      <NativeObject
                        app={app}
                        reference={{ id: "kTPQ" }}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                      />
                    </Card>
                  </div>
                  <div
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <Card>
                      <NativeObject
                        app={app}
                        reference={{ id: "jRngB" }}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                      />
                    </Card>
                  </div>
                </div>
                <div
                  style={{
                    background: "#ebf3fb",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    padding: "8px",
                  }}
                >
                  <ModalButton
                    title="Visualizar PDVs"
                    onClick={() => showModalPdvs(1)}
                    color="#F6540E"
                    pdv
                    tooltip="Visualize a listagem de PDVs com oportunidade de positivação com Itens OCS"
                  />
                </div>
              </div>
            </ConjuntoWrapper>
          </Card>
        </div>
      </div>
    </div>
  );
}

BasketMixMobile.defaultProps = {
  app: null,
  config: {},
};

BasketMixMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default BasketMixMobile;
